import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["content", "overlay"];

  initialize() {
    this.focusFirstButton();
  }

  close() {
    this.contentTarget.classList.add("Notice--hide");
    this.overlayTarget.classList.add("NoticeOverlay--hide");

    setTimeout(() => {
      if (this.hasContentTarget && this.contentTarget.parentNode) {
        this.contentTarget.parentNode.removeChild(this.contentTarget);
      }
      if (this.hasOverlayTarget && this.overlayTarget.parentNode) {
        this.overlayTarget.parentNode.removeChild(this.overlayTarget);
      }
    }, 750);
  }

  // Focus the first button found in the notice
  focusFirstButton() {
    if (!this.hasContentTarget) return;
    
    // Look for any button in the modal
    const buttons = this.contentTarget.querySelectorAll('button, .Button, [role="button"], .Button--close');
    
    // Focus the first button if found
    if (buttons.length > 0) {
      buttons[0].focus();
    }
  }
}

